export interface Auth {
    isAuthenticated?: boolean;
    isLoading?: boolean;
    isValidating?: boolean;
    nr?: number;
    mail?: string;
    name?: string;
    kz?: string;
    rolle?: string;
    message?: string;
    error?: string;
}

export interface AuthActionPayload {
    success?: boolean;
    auth: Auth;
}

export interface AuthAction {
    type: string;
    payload?: AuthActionPayload;
}

export enum AuthActionType {
    REQUEST_AUTH = 'AUTH/REQUEST_AUTH',
    REQUEST_AUTH_VALIDATE = 'AUTH/REQUEST_AUTH_VALIDATE',
    RECEIVE_AUTH_LOGIN = 'AUTH/RECEIVE_AUTH_LOGIN',
    RECEIVE_AUTH_CHANGE_PASSWORD = 'AUTH/RECEIVE_AUTH_CHANGE_PASSWORD',
    RECEIVE_AUTH_LOGOUT = 'AUTH/RECEIVE_AUTH_LOGOUT',
    REMOVE_PERSISTENT_USER = 'AUTH/REMOVE_PERSISTENT_USER',
}

export const defaultAuth: Auth = {
    isAuthenticated: false,
    isLoading: false,
    nr: 0,
    mail: '',
    name: '',
    kz: '',
    rolle: '',
};
